import { useContext, useEffect } from "react";
import FilterContext from "common/FilterContext";
import ActionsContext from "common/ActionsContext";

const useFilter = (view, defaults=null, returnView=undefined) => {
  const [get, put, clear] = useContext(FilterContext)
  const actions = useContext(ActionsContext);
  const setSettings = (settings) =>
    put(view, settings)
  const settings = get(view) || get(returnView) || defaults;
  const reset = () => clear(view);
  const onChange = (event) => {
    const { target } = event;
    const value =
      target.type !== "checkbox"
        ? target.value
        : target.value === "on" && target.checked === true;
    setSettings({
      ...settings,
      [target.name]: value,
    });
  };
  const onChangeValue = (value, name)=> {
    setSettings({
      ...settings,
      [name]: value,
    });
  }
  useEffect( () => actions.recv('do-load', reset), []);

  useEffect( () => {
    window.document.addEventListener("sidebar-view-change", reset, false);
    return window.removeEventListener("sidebar-view-change", window.document);
  } , []);

  return [settings, onChange, onChangeValue];
}

export default useFilter;
